var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.804 3.089a.6.6 0 0 1 .6.6v15.174l3.132-3.13a.6.6 0 0 1 .849.847l-4.156 4.156a.6.6 0 0 1-.145.103q-.025.016-.053.027-.017.006-.035.011-.037.015-.077.023a.6.6 0 0 1-.231 0q-.04-.008-.078-.023l-.035-.01q-.027-.013-.052-.028a.6.6 0 0 1-.143-.102L2.225 16.58a.599.599 0 1 1 .847-.848l3.132 3.131V3.688a.6.6 0 0 1 .6-.6m10.272.012a.6.6 0 0 1 .234 0l.045.012q.035.009.069.022a.6.6 0 0 1 .194.13l4.157 4.155a.6.6 0 0 1-.85.849l-3.13-3.132v15.176a.6.6 0 0 1-1.2 0V5.134l-3.133 3.134a.6.6 0 1 1-.848-.85l4.156-4.154a.593.593 0 0 1 .272-.154q.017-.007.034-.01"
  })));
};
export default SvgSort;